export const blockIconsTextformattingFileCopyNew = (
	<span className='material-symbols-outlined'>file_copy</span>
);
